import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
function UnknownSolidIcon(props, ref) {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    ...props,
    children: /*#__PURE__*/_jsx("path", {
      d: "M12.999 13.011v-.004.005Zm-9.412 7.402C3.98 20.803 4.45 21 5 21h14c.55 0 1.02-.196 1.413-.587A1.93 1.93 0 0 0 21 19V5c0-.55-.196-1.02-.587-1.413A1.926 1.926 0 0 0 19 3H5c-.55 0-1.02.196-1.413.587A1.926 1.926 0 0 0 3 5v14c0 .55.196 1.02.587 1.413ZM12 9a1 1 0 0 0-1 1 1 1 0 1 1-2 0 3 3 0 1 1 4.44 2.633 1.404 1.404 0 0 0-.383.288.3.3 0 0 0-.057.085A1 1 0 0 1 11 13c0-.58.253-1.047.539-1.38.281-.33.63-.572.94-.742A1 1 0 0 0 12 9Zm1 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    })
  });
}
;
UnknownSolidIcon.displayName = "UnknownSolidIcon";
export default forwardRef(UnknownSolidIcon);